import React from 'react'
import ClipSaver from './Audio/ClipSaver'
import Search from './Search';
function Feature() {
    return (
        <div>
            <ClipSaver />
            <Search />
        </div>
    )
}

export default Feature
